<template>
  <div class="LKMunMehFormFooter">
    <v-layout class="LKMunMehFormFooter__layout">
      <v-btn
        v-if="!onlyDeletion"
        color="primary"
        rounded
        outlined
        :disabled="isAppendDisabled"
        @click="$emit('append:document')"
        v-text="'Добавить документ'"
      />
      <v-spacer />
      <v-checkbox
        v-if="!onlyDeletion"
        v-model="lazyValue"
        label="Документы отсутствуют"
        :disabled="disabled"
        dense
        hide-details
      />
      <v-btn
        :color="selectedForDelete ? 'error' : 'primary'"
        rounded
        outlined
        depressed
        class="ml-btn"
        :disabled="isDeleteDisabled"
        @click="onClick"
      >
        {{ selectedForDelete ? 'Будет удалено после сохранения' : 'Удалить документ' }}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'LKMunMehFormFooter',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    docs: {
      type: Array,
      default: () => [],
    },
    onlyDeletion: Boolean,
    selectedForDelete: Boolean,
    disabled: Boolean,
  },
  computed: {
    isAppendDisabled() {
      return this.value || this.docs?.length >= 5 || this.disabled
    },
    isDeleteDisabled() {
      return this.value || this.docs?.length <= 0 || this.disabled
    },
    lazyValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    onClick() {
      this.$nextTick(() => {
        this.$emit('delete')
      })
    },
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormFooter {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  &__layout {
    align-items: center;

    .v-input--checkbox {
      padding: 0;
      margin: 0;
    }
  }

  .ml-btn {
    margin-left: 12px;
  }
}
</style>
